import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import DataTableCard from "../../components/common/DataTableCard";
import PageHero from "../../components/common/PageHero";
import { _Post } from "../../ApiEndPoint/ApiCalling";
import { BankAccount_Report } from "../../ApiEndPoint/Api";

export default function BankStatement() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [allData, setAllData] = useState([]);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");

  // 🔥 API CALL
  const fetchData = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("userData"));
      const res = await _Post(BankAccount_Report, user?.database, user?._id);

      if (res?.BankAccount?.length) {
        const uniqueBanks = [
          ...new Set(res.BankAccount.map((i) => i.bankSelect)),
        ].filter(Boolean);

        const grouped = {};

        // 🔥 Group by bank
        res.BankAccount.forEach((item) => {
          const bank = item.bankSelect || "Unknown";
          if (!grouped[bank]) grouped[bank] = [];
          grouped[bank].push(item);
        });

        // 🔥 Running balance per bank
        Object.keys(grouped).forEach((bank) => {
          let entries = grouped[bank];

          let openingBalance = Number(
            entries[0]?.bankDetails?.openingBalance || 0
          );

          if (entries[0]?.bankDetails?.openingType === "debit") {
            openingBalance = -openingBalance;
          }

          let running = openingBalance;

          const openingRow = {
            date: "",
            particular: "Opening Balance",
            type: openingBalance >= 0 ? "receipt" : "payment",
            amount: Math.abs(openingBalance),
            cashRunning: running,
            bankSelect: bank,
          };

          entries.sort((a, b) => new Date(a.date) - new Date(b.date));

          const final = [openingRow, ...entries];

          final.forEach((e, i) => {
            if (i === 0) return;

            const amt = Number(e.amount || 0);

            if (e.type === "payment") {
              running -= amt;
            } else {
              running += amt;
            }

            e.cashRunning = running;
            e.date = e?.date?.split("T")[0] || "";
          });

          grouped[bank] = final;
        });

        const merged = Object.values(grouped).flat();

        const firstBank = uniqueBanks[0];

        setAllData(merged);
        setBanks(uniqueBanks);
        setSelectedBank(firstBank);
        setRows(merged.filter((r) => r.bankSelect === firstBank));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // 🔥 Bank filter
  const handleBankChange = (bank) => {
    setSelectedBank(bank);
    const filtered = allData.filter((r) => r.bankSelect === bank);
    setRows(filtered);
  };

  return (
    <div className="erp-page-grid">

      {/* 🔥 HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <h5>Bank Transactions</h5>

        {/* 🔥 Bank Dropdown */}
        <Input
          type="select"
          value={selectedBank}
          onChange={(e) => handleBankChange(e.target.value)}
          style={{ width: "200px", height: "32px", fontSize: "12px" }}
        >
          {banks.map((b, i) => (
            <option key={i}>{b}</option>
          ))}
        </Input>
      </div>

      {/* 🔥 TABLE */}
      <DataTableCard
        loading={loading}
        columns={[
          { key: "date", label: "Date" },
          { key: "particular", label: "Particular" },
          { key: "debit", label: "Debit" },
          { key: "credit", label: "Credit" },
          { key: "balance", label: "Balance" },
        ]}
        rows={rows.map((r) => ({
          date: r.date || "-",
          particular:
            r.particular ||
            r?.partyId?.CompanyName ||
            r?.expenseId?.title ||
            "-",

          debit: r.type === "payment" ? `₹${r.amount}` : "-",
          credit: r.type === "receipt" ? `₹${r.amount}` : "-",
          balance: `₹${Number(r.cashRunning || 0).toFixed(2)}`,
        }))}
      />
    </div>
  );
}